"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const BasicButton_1 = require("../BasicButton");
const BasicTooltip_1 = require("../../4-card/BasicTooltip");
const useMountedState_1 = tslib_1.__importDefault(require("react-use/lib/useMountedState"));
const check_1 = tslib_1.__importDefault(require("iconista/lib/react/atlaskit/check"));
const copy_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/copy"));
const copy = require('clipboard-copy'); // eslint-disable-line
const CheckIcon = (props) => React.createElement(check_1.default, { ...props });
const CopyIcon = (props) => React.createElement(copy_1.default, { ...props });
const CopyButton = ({ onCopy, tooltip, ...rest }) => {
    const [t] = (0, use_t_1.useT)();
    const isMounted = (0, useMountedState_1.default)();
    const [copied, setCopied] = React.useState(false);
    const handleClick = (e) => {
        setCopied(true);
        copy(onCopy());
        setTimeout(() => {
            if (isMounted())
                setCopied(false);
        }, 2000);
        rest.onClick?.(e);
    };
    return (React.createElement(BasicTooltip_1.BasicTooltip
    // anchor={anchor}
    , { 
        // anchor={anchor}
        show: copied || void 0, renderTooltip: copied ? () => t('Copied!') : () => t('Copy'), ...tooltip },
        React.createElement(BasicButton_1.BasicButton, { ...rest, onClick: handleClick },
            React.createElement("div", { style: { position: 'relative', width: 16, height: 16, overflow: 'hidden' } },
                React.createElement("div", { style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        transform: copied ? 'translateY(100%)' : 'translateY(0%)',
                        transition: 'transform 150ms ease-in-out',
                    } },
                    React.createElement(CopyIcon, { width: 16, height: 16 })),
                React.createElement("div", { style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        transform: copied ? 'translateY(0%)' : 'translateY(-100%)',
                        transition: 'transform 150ms ease-in-out',
                    } },
                    React.createElement(CheckIcon, { width: 16, height: 16 }))))));
};
exports.CopyButton = CopyButton;
